var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuizSmartTool = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 53,
  height: 53,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M43.833 21.288v-5.85c0-3.64 0-5.46-.708-6.85a6.5 6.5 0 0 0-2.84-2.841c-1.391-.709-3.211-.709-6.852-.709H19.567c-3.64 0-5.46 0-6.851.709a6.5 6.5 0 0 0-2.84 2.84c-.71 1.39-.71 3.211-.71 6.851v22.534c0 3.64 0 5.46.71 6.85a6.5 6.5 0 0 0 2.84 2.841c1.39.709 3.21.709 6.85.709h11.267m0-23.834h-13m4.334 8.667h-4.334m17.334-17.333H17.833M36.25 33.21a4.871 4.871 0 0 1 9.467 1.624c0 3.247-4.872 4.871-4.872 4.871m.063 6.5h.022",
  stroke: "url(#quiz-smart-tool_svg__a)",
  strokeWidth: 4.34,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "quiz-smart-tool_svg__a",
  x1: 45.717,
  y1: 26.705,
  x2: 9.167,
  y2: 26.705,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A76CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D83CF3"
})))));
export default SvgQuizSmartTool;